import Nullstack from 'nullstack';
export default function IconVectorBezierCircle({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-vector-bezier-circle",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "10",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "17",
    y: "10",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "10",
    y: "3",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "10",
    y: "17",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M19 10a5 5 0 0 0 -5 -5"
  }), "   ", Nullstack.element("path", {
    d: "M19 14a5 5 0 0 1 -5 5"
  }), "   ", Nullstack.element("path", {
    d: "M5 14a5 5 0 0 0 5 5"
  }), "   ", Nullstack.element("path", {
    d: "M5 10a5 5 0 0 1 5 -5"
  }), " ");
}